import { render, staticRenderFns } from "./settingsMg.vue?vue&type=template&id=047eec21&scoped=true&"
import script from "./settingsMg.vue?vue&type=script&lang=js&"
export * from "./settingsMg.vue?vue&type=script&lang=js&"
import style0 from "./settingsMg.vue?vue&type=style&index=0&id=047eec21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047eec21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('047eec21')) {
      api.createRecord('047eec21', component.options)
    } else {
      api.reload('047eec21', component.options)
    }
    module.hot.accept("./settingsMg.vue?vue&type=template&id=047eec21&scoped=true&", function () {
      api.rerender('047eec21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settingsMg.vue"
export default component.exports